// ===========================================================================
// ProCare.SG — Firebase client initialisation
// ---------------------------------------------------------------------------
// These values are *identifiers*, not secrets. Firebase deliberately ships the
// web config in the client bundle; access is controlled by Firestore/Storage
// security rules and Firebase Authentication, not by hiding this object.
// Genuine credentials (SMTP passwords, API keys) live only in the Cloud
// Functions environment and never reach the browser.
//
// Every value can still be overridden at build time with REACT_APP_FIREBASE_*
// environment variables, which is how you would point a staging build at a
// different project.
// ===========================================================================
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const env = process.env;

export const firebaseConfig = {
    apiKey: env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCFWAE0iOj9YGX8R2msYQHaFPY5LgU2N9o",
    authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN || "procaresg.firebaseapp.com",
    projectId: env.REACT_APP_FIREBASE_PROJECT_ID || "procaresg",
    storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET || "procaresg.firebasestorage.app",
    messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "261159207162",
    appId: env.REACT_APP_FIREBASE_APP_ID || "1:261159207162:web:f0ca14cf62ea4af7044943",
};

// Cloud Functions run in Singapore — see functions/src/config.js.
export const FUNCTIONS_REGION = env.REACT_APP_FIREBASE_REGION || "asia-southeast1";

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, FUNCTIONS_REGION);
